import { useEffect } from "react";
import { withAppContext } from "src/store/initAppContext";
import styled, { withTheme } from "styled-components";
import config from "src/config/config";
import { theme } from "styled-tools";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PlaceholderImage from "src/components/Placeholder";

function JetXSmartSoft5FreeBetsPromo(props: any) {
    const { theme: currentTheme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const imageBaseUrl = `${config.imageV3Host}/static/cashsite`;

    const claimSteps = [
        {
            image: currentTheme.image.JetXSmartSoft5FreeBetsStep1,
            alt: "JetX aircraft",
            content: (
                <>
                    Place <strong>5 Cash Rounds</strong>
                    <br />
                    On <strong>JetX.</strong>
                </>
            ),
        },
        {
            image: currentTheme.image.JetXSmartSoft5FreeBetsStep2,
            alt: "Free bets gift",
            content: (
                <>
                    Get <strong>5 Free Bets</strong> Credited
                    <br />
                    Instantly To Your Account.
                </>
            ),
        },
        {
            image: currentTheme.image.JetXSmartSoft5FreeBetsStep3,
            alt: "Coins and winnings",
            content: (
                <>
                    Use Your <strong>Free Bets</strong>
                    <br />
                    <strong>To Win Big!</strong>
                </>
            ),
        },
    ];

    return (
        <InformationWrapper>
            <ContentWrapper>
                <BannerWrapper>
                    <LazyLoadImage
                        src={`${imageBaseUrl}/${currentTheme.image.JetXSmartSoft5FreeBetsPromoTopImg}`}
                        alt="Win your share of ₹1 crore in JetX free bets!"
                        effect="none"
                        placeholder={<PlaceholderImage />}
                    />
                </BannerWrapper>

                <ClaimSection>
                    <h2>How To Claim</h2>

                    <ClaimGrid>
                        {claimSteps.map((step, index) => (
                            <ClaimCard key={step.alt}>
                                <StepImageWrapper>
                                    <LazyLoadImage
                                        src={`${imageBaseUrl}/${step.image}`}
                                        alt={step.alt}
                                        effect="none"
                                        placeholder={<PlaceholderImage />}
                                    />
                                </StepImageWrapper>

                                <StepDescription>
                                    <StepNumber>{index + 1}</StepNumber>

                                    <p>{step.content}</p>
                                </StepDescription>
                            </ClaimCard>
                        ))}
                    </ClaimGrid>

                    <ReminderBar>
                        <ClockWrapper aria-hidden="true">
                            <svg
                                width="27"
                                height="27"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <circle
                                    cx="12"
                                    cy="12"
                                    r="11"
                                    fill="currentColor"
                                />
                                <path
                                    d="M12 5.5V12L16 15"
                                    stroke="#623541"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </ClockWrapper>

                        <p>Use Your Free Bets Within 48 Hours.</p>
                    </ReminderBar>
                </ClaimSection>

                <TermsSection>
                    <h2>Terms &amp; Conditions</h2>

                    <TermsList>
                        <li>
                            The Promotion Is Valid From{" "}
                            <strong>
                                1st November To 31st December.
                            </strong>
                        </li>

                        <li>
                            Players Must <strong>Place 5 Cash Rounds</strong> Of At
                            Least <strong>₹10</strong> Each On JetX During The
                            Promotion Period To Qualify.
                        </li>

                        <li>
                            Each Eligible Player Will Receive{" "}
                            <strong>5 Free Bets</strong> Worth{" "}
                            <strong>₹10 Each.</strong>
                        </li>

                        <li>
                            Free Bets Will Be Credited Instantly Once All
                            Qualifying Criteria Are Met.
                        </li>

                        <li>
                            Each Player Can Claim This Promotion Only Once During
                            The Promotion Period.
                        </li>

                        <li>
                            Free Bets Must Be Used Within 48 Hours Of Being
                            Credited. Unused Free Bets Will Expire After This
                            Period.
                        </li>

                        <li>
                            Only Winnings From Free Bets Will Be Credited To The
                            Player&apos;s Account. The Free-Bet Stake Itself Is
                            Non-Withdrawable.
                        </li>

                        <li>
                            The Total Promotional Free-Bet Pool Is Capped At
                            ₹1 Crore.
                        </li>

                        <li>
                            The Promotion Is Subject To The Applicable
                            Promotional Rules And Conditions.
                        </li>
                    </TermsList>
                </TermsSection>
            </ContentWrapper>
        </InformationWrapper>
    );
}

export default withTheme(withAppContext(JetXSmartSoft5FreeBetsPromo));

/* =========================================================
   MAIN BACKGROUND
========================================================= */

const InformationWrapper = styled.div`
    box-sizing: border-box;
    width: calc(100% - 2.4em);
    min-height: 100vh;
    margin: 0 1.2em;
    padding: 16px 24px 40px;

    color: #fff;
    background-color: #00113e;
    background-image: url(${config.imageV3Host}/static/cashsite/${theme(
        "image.JetXSmartSoft5FreeBetsPromoBg"
    )});
    background-position: top center;
    background-size: cover;
    background-repeat: no-repeat;
    border: 1px solid #cf8b0969;

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    h2,
    p {
        margin: 0;
    }

    h2 {
        color: #ffe600;
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        line-height: 26px;
    }

    @media (max-width: 768px) {
        width: 100%;
        margin: 0;
        padding: 16px 15px 32px;
    }
`;

const ContentWrapper = styled.div`
    width: 100%;
    max-width: 944px;
    margin: 0 auto;
`;

/* =========================================================
   PROMOTION BANNER
========================================================= */

const BannerWrapper = styled.div`
    width: 100%;
    overflow: hidden;
    border-radius: 8px;

    span {
        display: flex !important;
    }
    img {
        display: block;
        width: 100%;
        height: auto;
    }
`;

/* =========================================================
   HOW TO CLAIM
========================================================= */

const ClaimSection = styled.section`
    width: 100%;
    margin-top: 32px;

    @media (max-width: 768px) {
        margin-top: 26px;
    }
`;

const ClaimGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 38px;

    width: 100%;
    margin-top: 24px;

    @media (max-width: 992px) {
        gap: 20px;
    }

    @media (max-width: 768px) {
        gap: 12px;
    }

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
        gap: 16px;

        max-width: 360px;
        margin-right: auto;
        margin-left: auto;
    }
`;

const ClaimCard = styled.div`
    display: flex;
    flex-direction: column;

    min-width: 0;
    min-height: 221px;
    padding: 16px 20px 22px;

    background: rgba(0, 9, 35, 0.55);
    border: 1px solid #b6bfd3;
    border-radius: 13px;

    @media (max-width: 768px) {
        padding: 14px 12px 18px;
    }

    @media (max-width: 600px) {
        min-height: 210px;
        padding: 16px 22px 22px;
    }
`;

const StepImageWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 124px;
    margin-bottom: 13px;

    img {
        display: block;
        width: 100%;
        max-width: 220px;
        height: 124px;
        object-fit: contain;
    }

    @media (max-width: 768px) and (min-width: 601px) {
        height: 105px;

        img {
            height: 105px;
        }
    }
`;

const StepDescription = styled.div`
    display: flex;
    align-items: center;
    gap: 11px;

    margin-top: auto;

    p {
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        line-height: 19px;
    }

    strong {
        font-weight: 700;
    }

    @media (max-width: 992px) {
        gap: 9px;

        p {
            font-size: 14px;
            line-height: 19px;
        }
    }

    @media (max-width: 768px) and (min-width: 601px) {
        align-items: flex-start;

        p {
            font-size: 13px;
            line-height: 18px;
        }
    }

    @media (max-width: 600px) {
        p {
            font-size: 16px;
            line-height: 21px;
        }
    }
`;

const StepNumber = styled.span`
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;

    width: 43px;
    height: 43px;

    color: #fff;
    background: ${theme('palette.jetXSmartSoft5FreeBetsStepNumberBG')};
    border-radius: 50%;

    font-size: 26px;
    font-weight: 700;
    line-height: 1;

    @media (max-width: 768px) and (min-width: 601px) {
        width: 34px;
        height: 34px;
        font-size: 21px;
    }
`;

/* =========================================================
   48-HOUR REMINDER
========================================================= */

const ReminderBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    min-height: 66px;
    margin-top: 23px;
    padding: 12px 20px;

    color: #ff5c1b;
    background: rgba(255, 92, 27, 0.28);
    border-radius: 6px;

    p {
        padding-left: 23px;

        color: #ff5c1b;
        font-size: 18px;
        font-weight: 700;
        line-height: 25px;
    }

    @media (max-width: 600px) {
        padding: 12px 14px;

        p {
            padding-left: 14px;
            font-size: 14px;
            line-height: 20px;
        }
    }
`;

const ClockWrapper = styled.span`
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;

    min-height: 39px;
    padding-right: 24px;
    border-right: 2px solid #ff5c1b;

    @media (max-width: 600px) {
        padding-right: 14px;
    }
`;

/* =========================================================
   TERMS & CONDITIONS
========================================================= */

const TermsSection = styled.section`
    width: 100%;
    margin-top: 33px;
`;

const TermsList = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 11px;

    width: 100%;
    max-width: 568px;
    margin: 23px auto 0;
    padding: 0;

    list-style: none;

    li {
        position: relative;

        padding: 5px 18px 5px 42px;

        color: #fff;
        background: #707070;

        font-size: 16px;
        font-weight: 400;
        line-height: 25px;
        text-align: left;
    }

    li::before {
        content: "✦";
        position: absolute;
        top: 5px;
        left: 25px;

        color: #fff;
        font-size: 16px;
        line-height: 25px;
    }

    strong {
        font-weight: 700;
    }

    @media (max-width: 600px) {
        gap: 10px;
        margin-top: 20px;

        li {
            padding: 8px 12px 8px 30px;
            font-size: 14px;
            line-height: 22px;
        }

        li::before {
            top: 8px;
            left: 13px;
            font-size: 14px;
            line-height: 22px;
        }
    }
`;